@if (isAdminOrSuper || !settingsService.getRegion()?.code) {
  <s1-input-select (onSelectChange)="changed($event)" [readonly]="!(showAll || companySelected)" class="col-6 mb-2 fix-margin" [control]="control" [bindAllObject]="bindAllObject" [itemsList]="regionsList" [label]="'fields.input.region'" [labelGrouped]="false" [placeholder]="placeholder"></s1-input-select>
}
@if (!isAdminOrSuper && settingsService.getRegion()?.code) {
  <s1-input-label class="col-6 mb-2 fix-margin" [label]="'fields.input.region'" [grouped]="false">
    <input class="form-control" type="text" [readonly]="true" value="{{settingsService.getRegion()?.label}}"/>
  </s1-input-label>
}